module.exports = __webpack_public_path__ + "img/fanglz_b.e0ba3adf.png";